<template>
    <div>
        <v-toolbar>
            <v-checkbox v-model="onlyActive" label="ONLY ACTIVE LOTS" hide-details></v-checkbox>
            <v-spacer></v-spacer>
            APPLY TO MULTIPLE VINTAGES
            <v-spacer></v-spacer>
            <v-checkbox v-model="onlyThisVintage" label="ONLY THIS VINTAGE" hide-details></v-checkbox>
        </v-toolbar>
        <v-data-table
          :headers='headers'
          :items='lotsTable'
          hide-actions
          >
          <template slot="items" slot-scope="props">
                <tr>
                  <td width="50px">
                    <v-checkbox :disabled="props.item.lotNumber == primaryLot"
                        v-model="props.item.isSelected"
                        @change="valueChanged(props.item, props.index)"
                        hide-details
                    ></v-checkbox>
                  </td>
                  <td width="150px">{{ props.item.lotNumber }}</td>
                  <td width="150px">{{ props.item.description }}</td>
                  <td width="75px" v-if="props.item.isSelected">{{ props.item.volume }}</td>
                  <td width="75px">
                    <v-text-field v-if="props.item.isSelected"
                                  v-model="props.item.transferOut"
                                  @change="valueChanged(props.item, props.index)"
                                  hide-details></v-text-field>
                  </td>
                  <td width="75px" v-if="props.item.isSelected">{{ props.item.remaining }}</td>
                </tr>
          </template>
        </v-data-table>
    </div>
</template>

<script>
import myMixins from '../mixins/myMixins'
import axios from 'axios'
import moment from 'moment'
export default {
  props: ['selectedLots', 'wo', 'date', 'primaryLot'], // primaryLot is the lot of the parent workorder. we need to know this to prevent unselecting that lot.
  mixins: [myMixins],
  data () {
    return {
      onlyActive: true,
      onlyThisVintage: true,
      selected: this.selectedLots,
      lotsTable: [
        {
          isSelected: false,
          transferOut: 0,
          volume: 0,
          remaining: 0
        }
      ],
      dataByKey: {},
      headers: [
        { text: 'Select', value: 'select', sortable: false },
        { text: 'Lot #', value: 'lotNumber', sortable: true },
        { text: 'Lot Name', value: 'description', sortable: true },
        { text: 'Current Volume', value: 'currentVolume', sortable: false },
        { text: 'Transfer', value: 'transferOut', sortable: false },
        { text: 'Remaining', value: 'remaining', sortable: false }
      ]
    }
  },
  watch: {
    selectedLots: function () {
      let $this = this
      this.selected = this.selectedLots
      this.dataByKey = {}
      this.selected.forEach(function (lot) {
        $this.dataByKey[lot.lotNumber] = lot
      })
      this.updateLotsTable()
    },
    onlyActive: function () {
      this.updateLotsTable()
    },
    onlyThisVintage: function () {
      this.updateLotsTable()
    }
  },
  created () {
    let $this = this
    if (typeof this.wo.BlendItems !== 'undefined') {
      this.wo.BlendItems.forEach(function (blendItem) {
        $this.dataByKey[blendItem.sourceLot] = blendItem
        $this.dataByKey[blendItem.sourceLot].isSelected = true
      })
    }
    this.updateLotsTable()
  },
  methods: {
    // this is called anytime the user picks a different filter from all lots, to just active, to just vintage, and on creation
    updateLotsTable () {
      let $this = this
      this.lotsTable = JSON.parse(JSON.stringify(this.$store.state.allLotsForClient))
      this.lotsTable = this.lotsTable.filter(function (lot) {
        if ($this.primaryLot === lot.lotNumber) return false // can't blend with ourself
        if ($this.onlyActive && !lot.isActive) return false
        if ($this.onlyThisVintage && !(lot.year === $this.vintage)) return false
        return true
      })

      this.lotsTable.forEach(function (lot, index) {
        if ($this.dataByKey[lot.lotNumber]) {
          $this.lotsTable[index].isSelected = true

          // just remember that if you add anything in this list of things to be saved you need to  also modify the backend endpoint
          $this.lotsTable[index].volume = $this.dataByKey[lot.lotNumber].volume
          $this.lotsTable[index].transferOut = $this.dataByKey[lot.lotNumber].gallons

          $this.updateVolume($this.dataByKey[lot.lotNumber].sourceLot, $this.date, function (result) {
            $this.lotsTable[index].volume = result.structure.volume.total
            $this.lotsTable[index].remaining = result.structure.volume.total - $this.lotsTable[index].transferOut
            $this.dataByKey[$this.lotsTable[index].lotNumber].volume = result.structure.volume.total
          })
        } else {
          $this.lotsTable[index].isSelected = false
          $this.lotsTable[index].transferOut = 0
        }
      })
      this.$emit('blendingLotsUpdated', this.dataByKey)
    },
    isCompleteClicked (lotNumber) {
      this.dataByKey[lotNumber].isComplete = !this.dataByKey[lotNumber].isComplete
    },
    updateVolume (lot, date, complete) {
      let dateString = moment(date).subtract(1, 'd').format('YYYY-MM-DD')
      //      console.log(moment(date).subtract(1, 'd').format("YYYY-MM-DD"))
      let url = process.env.VUE_APP_BACKEND+
                    'workorders?lot=' + lot +
                    '&upToDate=' + dateString +
                    '&finalStructOnly=true'

      axios
        .get(url)
        .then(response => {
          complete(response.data.data)
        })
    },
    valueChanged (value, index) {
      this.lotsTable[index].transferOut = parseInt(this.lotsTable[index].transferOut)
      this.lotsTable[index].remaining = this.lotsTable[index].volume - this.lotsTable[index].transferOut
      this.dataByKey[this.lotsTable[index].lotNumber] = {
        isSelected: value.isSelected,
        blendId: this.wo.blendId,
        direction: 'IN FROM',
        gallons: value.transferOut,
        sourceLot: this.lotsTable[index].lotNumber
      }
      this.$emit('blendingLotsUpdated', this.dataByKey)
      if (value.isSelected) {
        let $this = this
        this.updateVolume(value.lotNumber, this.date, function (result) {
          $this.lotsTable[index].volume = result.structure.volume.total
          $this.dataByKey[$this.lotsTable[index].lotNumber].volume = result.structure.volume.total
        })
      }
    },
    isComplete (lotNumber) {
      if (this.dataByKey[lotNumber]) {
        return this.dataByKey[lotNumber].isComplete
      } else {
        return false
      }
    },
    woId (lotNumber) {
      if (this.dataByKey[lotNumber]) {
        return this.dataByKey[lotNumber].woId
      } else {
        return ''
      }
    },
    completed (lotNumber) {
      if (this.dataByKey[lotNumber]) {
        return this.dataByKey[lotNumber].status
      } else {
        return ''
      }
    }
  },
  computed: {
    vintage () {
      return this.$store.state.vintage
    },
    lots () {
      return this.$store.state.lotsForVintage
    },
    activeLots () {
      return this.$store.state.allActiveLotsForClient
    }
  }
}
</script>

<style scoped>
</style>
